import {defineStore} from 'pinia';
import {ref} from 'vue';

/**
 * Tracks app-wide error states that should block the current view without
 * navigating away — e.g. a lazy route chunk failing to load because the
 * server is unreachable. Kept separate from navigationProgress.store.ts
 * since progress is per-navigation and this persists until explicitly
 * cleared.
 */
export const useAppErrorStore = defineStore('appError', () => {
   const loadFailed = ref(false);

   const setLoadFailed = () => {
      loadFailed.value = true;
   };

   const clearLoadFailed = () => {
      loadFailed.value = false;
   };

   return {loadFailed, setLoadFailed, clearLoadFailed};
});
